import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-[80vh] flex items-center justify-center bg-[#FAFAFA]">
      <div className="max-w-lg mx-auto px-4 text-center">
        <div className="font-heading font-black text-8xl sm:text-9xl text-[#EE5A01]/15 leading-none mb-4 select-none">404</div>
        <h1 className="font-heading font-bold text-3xl sm:text-4xl text-[#121212] tracking-tight mb-4">
          Page not found
        </h1>
        <p className="font-body text-[#666666] mb-8">
          The page you are looking for may have been moved or does not exist. Let us get you back on the road.
        </p>
        <Link
          to="/"
          data-testid="back-home-btn"
          className="btn-primary inline-flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
